import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "@/components/NotificationBell";
import { LanguageSelector } from "@/components/LanguageSelector";
import { Plus, LayoutDashboard, LogOut, Search, Shield, Crown, Trophy, Mail, Wallet } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b-2 border-[#E6B31E]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Tradeable Exchange" className="w-10 h-10 rounded-lg object-cover" />
          <span className="font-display font-extrabold text-xl tracking-tight text-[#E6B31E] hidden sm:block">
            TRADEABLE<span className="text-white/90"> EXCHANGE</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 text-white">
          <LanguageSelector />
          <Link to="/browse" data-testid="nav-browse" className="hidden sm:flex items-center gap-1.5 font-bold text-sm px-3 py-2 hover:text-[#E6B31E] transition-colors">
            <Search size={16} strokeWidth={3} /> Browse
          </Link>
          <Link to="/leaderboard" data-testid="nav-leaderboard" className="hidden sm:flex items-center gap-1.5 font-bold text-sm px-3 py-2 hover:text-[#E6B31E] transition-colors">
            <Trophy size={16} strokeWidth={3} /> Leaderboard
          </Link>
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="flex items-center gap-1.5 font-bold text-sm text-[#E6B31E] px-3 py-2 hover:opacity-80 transition-opacity">
                  <Shield size={16} strokeWidth={3} /> <span className="hidden sm:inline">House</span>
                </Link>
              )}
              {!user.is_member && user.role !== "admin" && (
                <Link to="/membership" data-testid="nav-membership" className="flex items-center gap-1.5 font-bold text-sm text-[#E6B31E] px-3 py-2 hover:opacity-80 transition-opacity">
                  <Crown size={16} strokeWidth={3} /> <span className="hidden sm:inline">Membership</span>
                </Link>
              )}
              {user.is_member && (
                <Link to="/membership" data-testid="member-badge" title="Active member" className="hidden sm:flex items-center gap-1 font-extrabold text-xs bg-[#E6B31E] text-black rounded-full px-3 py-1">
                  <Crown size={13} strokeWidth={3} /> MEMBER
                </Link>
              )}
              <Link to="/create" data-testid="nav-create" className="flex items-center gap-1.5 font-bold text-sm bg-[#E6B31E] text-black border-2 border-[#E6B31E] rounded-full px-4 py-2 hover:bg-[#f5c841] transition-colors">
                <Plus size={16} strokeWidth={3} /> <span className="hidden sm:inline">List Item</span>
              </Link>
              <Link to="/dashboard" data-testid="nav-dashboard" className="flex items-center gap-1.5 font-bold text-sm px-3 py-2 hover:text-[#E6B31E] transition-colors">
                <LayoutDashboard size={16} strokeWidth={3} /> <span className="hidden sm:inline">Dashboard</span>
              </Link>
              <Link to="/wallet" data-testid="nav-wallet" className="flex items-center gap-1.5 font-bold text-sm px-3 py-2 hover:text-[#E6B31E] transition-colors">
                <Wallet size={16} strokeWidth={3} /> <span className="hidden sm:inline">Wallet</span>
              </Link>
              {user.role !== "admin" && (
                <Link to="/support" data-testid="nav-support" className="hidden sm:flex items-center gap-1.5 font-bold text-sm px-3 py-2 hover:text-[#E6B31E] transition-colors" title="Contact the House">
                  <Mail size={16} strokeWidth={3} />
                </Link>
              )}
              <NotificationBell />
              <button onClick={handleLogout} data-testid="nav-logout" className="flex items-center gap-1.5 font-bold text-sm px-2 py-2 hover:text-[#E6B31E] transition-colors" title="Log out">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full border-2 border-[#E6B31E] object-cover" />
                ) : (
                  <span className="w-8 h-8 rounded-full bg-[#E6B31E] border-2 border-[#E6B31E] text-black flex items-center justify-center font-extrabold">
                    {user.name?.[0]?.toUpperCase()}
                  </span>
                )}
                <LogOut size={15} strokeWidth={3} className="hidden sm:block" />
              </button>
            </>
          ) : (
            <Link to="/auth" data-testid="nav-login" className="font-bold text-sm bg-[#E6B31E] text-black border-2 border-[#E6B31E] rounded-full px-5 py-2 hover:bg-[#f5c841] transition-colors">
              Log in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
